@if (downloadFileModalConfig) {
  <ent-modal-popup class="download-file" [modalConfig]="downloadFileModalConfig" (closeModalPopup)="closedownloadFileModal()">
    <div modal-header>
      <h3 class="lfg-color">DOWNLOAD FILE(S)</h3>
      <div class="download-file-disc">
        <p>Please select the icon in the download column to access the document(s).</p>
      </div>
    </div>
    <div modal-body>
      <div class="msg-cont" aria-live="assertive">
        @if (isDownloadSuccess) {
          <ent-alert-message type="success" class="fade-out">Selected file(s) are downloaded successfully to your system and a record of this event has been stored in the comments below.</ent-alert-message>
        }
        @if (isDownloadFailure) {
          <ent-alert-message type="error">{{ message.fileUploadFailure }}</ent-alert-message>
        }
        @if (emptyFileListError) {
          <ent-alert-message type="error">{{ message.emptyFileListError }}</ent-alert-message>
        }
      </div>
      <div class="table-cont">
        @if (!emptyFileListError) {
          <table>
            <thead>
              <tr class="file-selected-header top-header">
                <th scope="col" class="file-name-cont file-name no-border-left"><h4>FILE NAME</h4></th>
                <th scope="col" class="file-name-cont action no-padding-left center-align"><h4>DOWNLOAD</h4></th>
                <th scope="col" class="file-name-cont action no-padding-left center-align no-border-right line-height"><h4>PREVIOUSLY DOWNLOADED</h4></th>
              </tr>
            </thead>
            <tbody>
              @if (requirementFileMetadata) {
                @for (file of requirementFileMetadata; track file; let i = $index; let even = $even) {
                  <tr class="file-selected-header">
                    <td class="file-name-cont file-name" [style.background-color]="even ? '#f2f4f6' : null">{{ file.fileName }}</td>
                    <td class="file-name-cont action center-align" [style.background-color]="even ? '#f2f4f6' : null">
                      <button type="button" entLinkButton (keydown)="onTab($event, i)"
                        (click)="downloadFile(file);" [ngStyle]="{'cursor: default': isDownloadSuccess || isHOUser() }" [ngClass]="{'btn--link-disabled': isDownloadSuccess || isHOUser() }">
                        <i class="fas fa-download" aria-hidden="true"></i>
                        <span class="screen-reader-only">download</span>
                      </button>
                    </td>
                    <td class="file-name-cont action center-align previously-downloaded" [style.background-color]="even ? '#f2f4f6' : null">
                      @if (file.downloaded) {
                        <i class="fas fa-check-circle" aria-hidden="true"></i>
                        <span class="screen-reader-only">check mark</span>
                      } @else {
                        <span>N/A</span>
                      }
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  </ent-modal-popup>
}
